import Navbar from "@/components/Navbar";
import CustomerAuthModal from "@/components/CustomerAuthModal";
import MyOrdersModal from "@/components/MyOrdersModal";
import TrackOrderModal from "@/components/TrackOrderModal";
import StylistChat from "@/components/StylistChat";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Manifesto from "@/components/Manifesto";
import Shop from "@/components/Shop";
import SizeGuide from "@/components/SizeGuide";
import ReviewsSection from "@/components/ReviewsSection";
import TrustGrid from "@/components/TrustGrid";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import CartDrawer from "@/components/CartDrawer";
import ProductModal from "@/components/ProductModal";
import CheckoutModal from "@/components/CheckoutModal";

export default function Home() {
  return (
    <div className="bg-cream text-ink min-h-screen" data-testid="home-page">
      <Navbar />
      <Hero />
      <Marquee />
      <Shop />
      <Manifesto />
      <SizeGuide />
      <ReviewsSection />
      <TrustGrid />
      <Footer />
      <WhatsAppFloat />
      <CartDrawer />
      <ProductModal />
      <CheckoutModal />
      <TrackOrderModal />
      <StylistChat />
      <CustomerAuthModal />
      <MyOrdersModal />
    </div>
  );
}
